<mat-dialog-content>{{ data.message | translate }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'message_dialog.ok' | translate }}</button>
</mat-dialog-actions>
